export function routes($stateProvider) {
    $stateProvider
        .state('app.lab.warehouse', {
        url: '/amostras',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.lab.warehouse.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Amostras',
        template: require('./directory/directory.view.html'),
        controller: 'LmeListWarehouseController',
        controllerAs: 'vm',
        role: 'amostrasLMEList',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.lab.warehouse.details', {
        url: '/{id}',
        controller: 'LmeDetailsWarehouseController',
        controllerAs: 'vm',
        role: 'amostrasLMEList',
        template: require('./details/details.view.html')
    });
}
routes.$inject = ['$stateProvider'];
